export const getCookie = (name: string): string | null => {
  if (typeof document === "undefined") return null

  const cookies = document.cookie.split("; ")
  const cookie = cookies.find((c) => c.startsWith(`${name}=`))

  if (!cookie) return null

  const value = cookie.split("=")[1] || null
  return value
}
